import getFirstAdminProduct from './getFirstAdminProduct';

export default (products, isHeaderEnabled) => {
  if (!products) return [];
  if (isHeaderEnabled) {
    return products.map((p, i, a) => {
      if (a[i - 1] && p.category !== a[i - 1].category) {
        return { ...p, hasDivider: true };
      }
      return p;
    });
  }

  const divingProductId = getFirstAdminProduct(products);
  return products.map((product, index) => {
    if (divingProductId === product.key && index !== 0) {
      return {
        ...product,
        hasDivider: true,
      };
    }

    return product;
  });
};
